export default "__VITE_ASSET__BnhQdkTc__"